import React from 'react';
import PropTypes from 'prop-types';
import { Drawer as AntdDrawer } from 'antd';

const Drawer = (props) => {
  const {
    children,
    className,
    closable,
    width,
    height,
    isOpen,
    onClose,
    placement,
    title,
    footer,
    headerClass,
    footerClass,
    bodyClass,
    showBackdrop,
    lockScroll,
    ...rest
  } = props;

  return (
    <AntdDrawer
      title={title}
      placement={placement}
      closable={closable}
      onClose={onClose}
      visible={isOpen}
      width={placement === 'left' || placement === 'right' ? width : undefined}
      height={placement === 'top' || placement === 'bottom' ? height : undefined}
      footer={footer}
      style={{
        background: showBackdrop ? undefined : 'transparent',
        overflow: lockScroll ? 'hidden' : 'auto'
      }}
      {...rest}>
      <div>{children}</div>
    </AntdDrawer>
  );
};

Drawer.propTypes = {
  placement: PropTypes.oneOf(['top', 'right', 'bottom', 'left']),
  width: PropTypes.number,
  height: PropTypes.number,
  closable: PropTypes.bool,
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  footer: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  headerClass: PropTypes.string,
  footerClass: PropTypes.string,
  bodyClass: PropTypes.string,
  showBackdrop: PropTypes.bool,
  lockScroll: PropTypes.bool,
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired
};

Drawer.defaultProps = {
  closable: true,
  width: 400,
  height: 400,
  placement: 'right',
  showBackdrop: true,
  lockScroll: true
};

export default Drawer;
